import { render, staticRenderFns } from "./CacheManage.vue?vue&type=template&id=0df87bd6&scoped=true"
import script from "./CacheManage.vue?vue&type=script&lang=js"
export * from "./CacheManage.vue?vue&type=script&lang=js"
import style0 from "./CacheManage.vue?vue&type=style&index=0&id=0df87bd6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df87bd6",
  null
  
)

export default component.exports